/**
 * FrontDesk Design System - Style Patterns
 *
 * Centralized exports for all reusable style patterns.
 * Import from here to access consistent styling across components.
 *
 * @example
 * import { ellipsisText, hoverHighlight, messageBubbleIncoming } from '@/widgets/frontdesk/design-system/styles';
 */

export * from './common.styles';
export * from './form.styles';
export * from './message.styles';
export * from './conversation.styles';

